import React from "react";

const EventPartnersBase = ({ partnersBaseData = [] }) => {
    if (!partnersBaseData.length) return null;

    // Последняя группа — медиапартнёры
    const lastIndex = partnersBaseData.length - 1;
    const regularGroups = partnersBaseData.slice(0, lastIndex);
    const mediaGroup = partnersBaseData[lastIndex];

    return (
        <section className="py-20">

            {/*  Верхняя часть — партнёры в 2 колонки */}
            <div className="max-w-screen-xl mx-auto px-[15px] mb-14 lg:mb-24">
                <div className="grid gap-y-10 gap-x-16 sm:grid-cols-2 lg:gap-y-14 xl:gap-x-20">
                    {regularGroups.map(
                        ({ partners_group: { group_status, tpb_items } }, groupIndex) => {
                            const mainItem = tpb_items[0]?.acf;

                            if (!mainItem) return null;

                            return (
                                <div key={groupIndex} className="flex flex-col text-center">
                                    {/* Заголовок */}
                                    <h3 className="font-bold uppercase text-[24px] sm:text-[26px] text-[#000] mb-3">
                                        {group_status}
                                    </h3>

                                    <div className="flex flex-grow gap-3 mb-8 md:mb-10">
                                        {/* Логотип */}
                                        <a
                                            href={mainItem.p_url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="flex bg-white p-2 mx-auto   justify-center items-center"
                                            style={{ ...(mainItem.p_logo_width && { maxWidth: `${mainItem.p_logo_width}px` }) }}
                                        >
                                            <img src={mainItem.p_thumbnail} alt={group_status} 
                                                className="inline-block object-contain"/>
                                        </a>
                                    </div>

                                    <div className="w-full h-[1px]
                                        bg-[linear-gradient(90deg,#b43125_0%,#245864_30.29%,#f5d858_56.25%,#95c8bf_76.92%,#245864_100%)]">
                                    </div>
                                </div>
                            );
                        }
                    )}
                </div>
            </div>

            {/*  Нижняя часть — МЕДІАПАРТНЕРИ  */}
            {mediaGroup && (
                <div className="container mx-auto mb-8 p-5 bg-white">
                    <h3 className="font-bold text-center uppercase text-[28px] sm:text-[32px] text-[#000] mb-5">
                        {mediaGroup.partners_group.group_status}
                    </h3>

                    <div className="grid grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 justify-center items-center">
                        {mediaGroup.partners_group.tpb_items.map(
                            ({ acf: { p_url, p_thumbnail, p_logo_width } }, idx) => (
                                <a
                                    key={idx}
                                    href={p_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-center block p-2 bg-white mx-auto"
                                    style={{ ...(p_logo_width && { maxWidth: `${p_logo_width}px` }) }}
                                >
                                    <img src={p_thumbnail} alt={mediaGroup.partners_group.group_status}
                                        className="inline-block object-contain"/>
                                </a>
                            )
                        )}
                    </div>
                </div>
            )}
        </section>
    );
};

export default EventPartnersBase;